import React, { useState } from "react";
import { InvoiceToPrint } from "../Components/InvoicePrint";
import {ReactComponent as Close } from "../assets/icons/x.svg"
import {ReactComponent as Download } from "../assets/icons/Download-white.svg"
import NewButton from "./NewButton";
import { QuoteSummaryToPrint } from "../Components/QuoteSummaryToPrint";
import { MultiInvoicePrint } from "../Components/MultiInvoicePrint";
import { SingleInvoicePrint } from "../Components/SingleInvoicePrint";
import { useSpring, animated } from "react-spring";

const OpenInvoiceModal = ({order, onClose, type = "order"}) => {
  
  const [download, setDownload] = useState("");
  const [loading, setLoading] = useState(false);
  const [showBtns, setShowBtns] = useState(false);
  
  const statusOverlayProps = useSpring({
      display: loading ? "flex" : "none",
  });

  const handleDownload = () => {
    if(!order){
      return;
    }
    setLoading(true);
    setDownload(order.id);
    setTimeout(() => setLoading(false), 2000);
  }


  return (
    <>
    {loading &&  <animated.div
      style={statusOverlayProps}
      className="checkoutStatusOverlay"
    >
      Downloading, Please wait<span className="dotsLoading">...</span>
    </animated.div>}
    <div className="openInvoiceModalWrap">
      <div
        className="openInvoiceModalContainer"
        style={{ alignItems: "center" }}
      >
        {type === "order" ? 
        <InvoiceToPrint
          orderInfo={order}
          setDownloadOrder={setDownload}
          downloadOrder={download}
          setShowBtns={setShowBtns}
        /> : type === "quote" ? 
        <QuoteSummaryToPrint 
          quoteInfo={order}
          setDownloadQuote={setDownload}
          downloadQuote={download}
          setShowBtns={setShowBtns}
        /> : type === "invoice" ? 
          order && order.type === "multipleInvoice" ? 
        <MultiInvoicePrint
          setDownloadInvoice={setDownload}
          downloadInvoice={download}
          invoice={order}
          setShowBtns={setShowBtns}
        /> :
        <SingleInvoicePrint
          invoice={order}
          setDownloadInvoice={setDownload}
          downloadInvoice={download}
          setShowBtns={setShowBtns}
        /> 
        : ""}
        <Close className="newPopUpModalCloseIcon" onClick={onClose} />
       {showBtns ? <div className="w-full fixed bottom-[30px] right-[0] flex justify-center items-center gap-2">
            <NewButton
                text={"Download Invoice"}
                width="100px"
                smallPadding
                onClick={handleDownload}
                customIcon={<Download/>}
              />
            <NewButton
                text={"Close"}
                back
                whiteBtn
                icon={false}
                width="100px"
                smallPadding
                onClick={onClose}
              />
        </div> : ""}
      </div>
    </div>
    </>
  );
};

export default OpenInvoiceModal;
